import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { RegulationService } from 'src/app/core/services/regulation';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { LinkedConnectionModel } from 'src/app/core/models/rulebook/linked-connection-model';
import {
  LinkedConnectionListView,
  LinkedConnectionListViewModel,
} from 'src/app/core/models/rulebook/linked-connection-list-view-model';
import { LinkedAppliedAcrossModel } from 'src/app/core/models/rulebook/linked-applied-across-model';
import { RulebookFilter } from 'src/app/core/models/rulebook';
import { BrifRulebookFilterModel } from 'src/app/core/models/rulebook/rulebook-filters-model';
import { PageEvent } from '@angular/material/paginator';
import { MatPaginationModel } from 'src/app/core/models/pagination/mat-paginator';
import { Table } from 'primeng/table';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-rules-connection',
  templateUrl: './rules-connection.component.html',
  styleUrls: ['./rules-connection.component.scss'],
})
export class RulesConnectionComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;
  @ViewChild('tableContent', { read: ElementRef })
  public tableContent: any;
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;

  toastModel: ToastViewModel;
  isToastShow = false;
  endIndex = 0;
  totalCount = 0;
  rulesConnectionData: Array<LinkedConnectionListView>;
  myInnerHeight: any;
  isLoading = false;
  linkedConnection: LinkedConnectionModel;
  deletedLinkedConnection:LinkedConnectionModel;
  linkedAppliedAcross: LinkedAppliedAcrossModel;
  deletedLinkedAppliedAcross:LinkedAppliedAcrossModel;
  previousSelectedIds: Array<number>;
  deletedIds: Array<number>;
  keyword:string='';
  filter:BrifRulebookFilterModel=new BrifRulebookFilterModel();
  paginationModel:MatPaginationModel=new MatPaginationModel();
  firstRow: number = 0; 
  pageEvent!: PageEvent;
  pageSize = this.paginationModel.pageSize;
  pageIndex = this.paginationModel.pageIndex;
  pageSizeOptions = this.paginationModel.pageSizeOptions;
  showFirstLastButtons = true;
  totalRowPerPage: number = this.pageSize;
  
  //totalCount: number = 0;
  constructor(
    private regulationService: RegulationService,
    public dialogRef: MatDialogRef<RulesConnectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.toastModel = new ToastViewModel();
    this.rulesConnectionData = [];
    this.myInnerHeight = window.innerHeight - 350;
    this.linkedConnection = new LinkedConnectionModel();
    this.linkedAppliedAcross = new LinkedAppliedAcrossModel();
    this.previousSelectedIds = [];
    this.deletedIds = [];
    this.deletedLinkedConnection = new LinkedConnectionModel();
    this.deletedLinkedAppliedAcross = new LinkedAppliedAcrossModel();
  }
  ngOnInit(): void {
    if(this.data.length>1){
      if (this.data[1] == false) {
        this.linkedConnection = this.data.length>0? this.data[0]:this.linkedConnection;
        if (this.linkedConnection.linkedConnections != null) {
          this.previousSelectedIds = [...this.linkedConnection.linkedConnections];
        }
        this.filter.instruction=false;
      } else if (this.data[1] == true) {
        this.linkedAppliedAcross =this.data.length>0? this.data[0]:this.linkedAppliedAcross;
        if (this.linkedAppliedAcross.linkedAppliesAcrossIds != null) {
          this.previousSelectedIds = [...this.linkedAppliedAcross.linkedAppliesAcrossIds];
        }
        this.filter.instruction=true;
      }
      this.BreifRulebookDataList(0);
    }
  }

  handler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
  }

  selectItem(event: any, id: number): void {
    if (this.data[1] == false) {
      if (event.target.checked === true) {
        this.linkedConnection.linkedConnections.push(id);
      } else {
        const index = (
          this.linkedConnection.linkedConnections as number[]
        ).indexOf(id);
        if (index >= 0) {
          (this.linkedConnection.linkedConnections as number[]).splice(
            index,
            1
          );
        }
      }
    } else if (this.data[1] == true) {
      if (event.target.checked === true) {
        this.linkedAppliedAcross.linkedAppliesAcrossIds.push(id);
      } else {
        const index = (
          this.linkedAppliedAcross.linkedAppliesAcrossIds as number[]
        ).indexOf(id);
        if (index >= 0) {
          (this.linkedAppliedAcross.linkedAppliesAcrossIds as number[]).splice(
            index,
            1
          );
        }
      }
    }
  }

  closeDialog(): void {
    if (this.data[1] == false) {
      if (this.previousSelectedIds.length > 0) {
        this.deletedIds = this.previousSelectedIds.filter(
          (num) => !this.linkedConnection.linkedConnections.includes(num)
        );
      }
      this.deletedLinkedConnection.currentID = this.linkedConnection.currentID;
      this.deletedLinkedConnection.linkedConnections = this.deletedIds;
      this.dialogRef.close([this.linkedConnection, this.deletedLinkedConnection]);
    } else if (this.data[1] == true) {
      if (this.previousSelectedIds.length > 0) {
        this.deletedIds = this.previousSelectedIds.filter(
          (num) => !this.linkedAppliedAcross.linkedAppliesAcrossIds.includes(num)
        );
      }
      this.deletedLinkedAppliedAcross.currentID = this.linkedAppliedAcross.currentID;
      this.deletedLinkedAppliedAcross.linkedAppliesAcrossIds = this.deletedIds;
      this.dialogRef.close([this.linkedAppliedAcross, this.deletedLinkedAppliedAcross]);
    }
  }

  checkedIfExist(id: number): string {
    if (this.data[1] == false) {
      const index = (
        this.linkedConnection.linkedConnections as number[]
      ).indexOf(id);
      return index >= 0 ? 'checked' : '';
    } else if (this.data[1] == true) {
      const index = (
        this.linkedAppliedAcross.linkedAppliesAcrossIds as number[]
      ).indexOf(id);
      return index >= 0 ? 'checked' : '';
    } else {
      return 'Something Went Wrong';
    }
  }

  closeAction() {
    this.dialogRef.close();
  }
  keywordSearch(){
    this.firstRow=0;
    this.filter.connectionHeader=this.keyword;
    this.BreifRulebookDataList(0);
  }
  BreifRulebookDataList(pageIndex: number) {
    this.firstRow=pageIndex*this.totalRowPerPage;
    if (this.firstRow < this.totalCount|| this.firstRow === 0) {
      this.filter.SkipCount = this.firstRow;
      this.filter.TakeCount = this.totalRowPerPage;
      this.isLoading = true;
      this.regulationService
      .getAddRemoveRulebookDataList(this.filter)
      .subscribe((res: LinkedConnectionListViewModel) => {
      this.rulesConnectionData = res.data;
      this.totalCount = res.totalCount;
      this.endIndex =
        this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
        
       if(this.viewport){
        this.viewport.scrollToIndex(0);
       }
        
        // if (this.firstRow + this.totalRowPerPage > this.totalCount) {
        //   this.firstRow = this.totalCount;
        // }
        // else {
        //   this.firstRow = this.firstRow + this.totalRowPerPage;
        // }
        this.isLoading = false;
      });
    }
  }
  onPagechange(event: PageEvent) {
    this.totalRowPerPage = event.pageSize;
    this.BreifRulebookDataList(event.pageIndex);
  }
  sortBreifRulebooks(key: string): void {
    this.firstRow = 0;
    this.filter.IsDesc = !this.filter.IsDesc;
    this.filter.SortKey = key;
      this.BreifRulebookDataList(0);
  }
  resetKeyWords(){
    this.keyword='';
    this.keywordSearch();
  }
}
